import { render, staticRenderFns } from "./IconSvgProfile.vue?vue&type=template&id=3f11cce0&scoped=true&"
import script from "./IconSvgProfile.vue?vue&type=script&lang=js&"
export * from "./IconSvgProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f11cce0",
  null
  
)

export default component.exports